module.exports = __webpack_public_path__ + "candle.279b90ba.png";